import { Injectable } from '@angular/core';
import { Angular2TokenService } from 'angular2-token';
import { Observable } from 'rxjs/Observable';
import { Action } from "@ngrx/store/src/dispatcher";

import { Ticket } from '@models/ticket';

@Injectable()
export class TicketService {

  private ticketsUrl: string = 'tickets';

  constructor(
    private http: Angular2TokenService,
  ) {}

  delete(id: number): Observable<number> {
    return this.http.delete(`${this.ticketsUrl}/${id}`)
      .map(() => id)
      .catch((error: Response) => Observable.throw(error.json()))
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/ticket.ts